import { WithChildren } from "../../../_metronic/helpers"
import { Provider } from "react-redux"
import { store } from './Store'

export default function AuthProvider({children}: WithChildren) {
  return <Provider store={store}>{children}</Provider>
}
